import React from 'react';

const formatDate = (dateObj,time) => {
    let dd = String(dateObj.getDate()).padStart(2, '0');
    let mm = String(dateObj.getMonth() + 1).padStart(2, '0');
    let yyyy = dateObj.getFullYear();
    return yyyy + '-' + mm + '-' + dd + 'T'+((time != undefined)?time:'00:00:00');
};

export default formatDate
